
  import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';


  export default defineComponent({
    name: 'FormFileInput',
    components: {
      Field,
      ErrorMessage,
    },
    props: {
      item: Object,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();
      const store = useStore();
      const router = useRouter();

      let currentItem: any = props.item;
      // currentItem.key = Math.random().toString(16);
      const state = reactive({
        item: currentItem,

        file: null,
        FileModel: null,
        LoaderProgress: 0,
        FileLoader: false,
      });

      const triggerClickUpdate = () => {
        let element = document.getElementById('imageFile');
        if (element) element.click();
      };
      const handleChangeImage = (evt: Event | any) => {
        let file = evt.target.files[0];
        let payload = new FormData();
        payload.append('path', 'FormFile');
        payload.append('isPublic', 'false');
        if(helpers.getUserId()) payload.append('userId', helpers.getUserId());
        payload.append('files', file);
        state.FileModel = file;
        uploadImage(payload);
      };
      const uploadImage = (payload) => {
        state.FileLoader = true;
        state.item.value = null
        state.LoaderProgress = 0;
        let config: any = {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function(progressEvent) {
            let uploadPercentage: number = (Math.round(((progressEvent.loaded / progressEvent.total) * 100)));
            state.LoaderProgress = uploadPercentage;
          },
        };
        let requestData = {
          formData: payload,
          config: config,
          storageKey: 'FormFile',
        };
        setTimeout(() => {
          store.dispatch('moduleCommon/uploadImage', requestData).then(({ data }) => {
            state.FileLoader = false;
            state.file = data.filesUrls[0];
            if (state.item) {
              if (data.filesUrls[0]) {
                const queryString = (new URL(data.filesUrls[0])).search;
                const urlParams = new URLSearchParams(queryString);
                let filePath:any = urlParams.get('filePath');
                state.item.value = filePath;
              }
            }
            setTimeout(() => {
              state.LoaderProgress = 0;
            }, 1000);
          }).catch((response) => {
            state.FileLoader = false;
            state.LoaderProgress = 0;
            helpers.handleResponse(response, i18n.t, router, store);
          });
        }, 10);
      };

      return {
        handleChangeImage,
        ...toRefs(state),
        i18n, store,
        helpers,
      };
    },
  });
